export const GET_ORGANISATION_USERS = "GET_ORGANISATION_USERS";

const settingsGetters = {
  [GET_ORGANISATION_USERS]: state => state.organisationUsers
};

export default settingsGetters;
